import React, {useContext} from 'react'
import {MyContext} from '../Actions/UAuth'
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";

// Importing the Login & Register Componet
import Login from './Login'
import Register from './Register'
// React Notification
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

function Home(){
    const {rootState,} = useContext(MyContext);
    const {isAuth,showLogin} = rootState;
    // If user Logged in
    if(isAuth)
    {
        return(
                <article>
                    <NotificationContainer />
                    <Header/>
                    <Aside/>  
                    <Footer/>   
                </article>
        )
    }
    // Showing Login Or Register Page According to the condition
    else if(showLogin){
        return  <div><NotificationContainer /><Login/></div>;
    }
    else{
        return <div><NotificationContainer /><Register/></div>;
    }    
}
export default Home;